const MONTH_LABELS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

export type ExpectedGraduationMonth = (typeof MONTH_LABELS)[number];

export const EXPECTED_GRADUATION_MONTH_OPTIONS: ReadonlyArray<{ value: ExpectedGraduationMonth; label: string }> =
  MONTH_LABELS.map((label) => ({ value: label, label }));

export function buildExpectedGraduationYearOptions(yearsAhead = 10): Array<{ value: string; label: string }> {
  const startYear = new Date().getFullYear();
  return Array.from({ length: yearsAhead }, (_, index) => {
    const year = (startYear + index).toString();
    return { value: year, label: year };
  });
}
